import React, { useState, useContext } from 'react'

export const ScrollBarsContext = React.createContext();
function ScrollBarsContextProvider(props) {
    const [scrollbars, setScrollbars] = useState(null);
    return (
        <ScrollBarsContext.Provider value={{ scrollbars, setScrollbars }}>
            {props.children}
        </ScrollBarsContext.Provider>
    )
}

export const Scrollbars = () => useContext(ScrollBarsContext);
export default ScrollBarsContextProvider;
